import { useSelector } from "react-redux";
import { getFareclassOptionFilter } from "@b2bportal/core-flights";
import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type FareclassShelfBrandName,
  FlightRatingsEnum,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useFlightListGridFilter } from "@tenant/flights";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FlightListGridFilter.module.scss";

const COMPONENT_KEY = CoreFlightsComponent.FlightListGridFilter;

export const FlightListGridFilter = ({
  className,
  children,
}: PlatformComponentProps) => {
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();
  const fareClasses = useSelector(getFareclassOptionFilter);
  const { handleFilterFareClasses } = useFlightListGridFilter();

  const filters = [
    {
      key: FlightRatingsEnum[FlightRatingsEnum.basic],
      label: t("fareClass.basicLabel"),
      details: t("fareClass.basicDetails"),
      icon: IconNameEnum.fareClassBasic,
    },
    {
      key: FlightRatingsEnum[FlightRatingsEnum.standard],
      label: t("fareClass.standardLabel"),
      details: t("fareClass.standardDetails"),
      icon: IconNameEnum.fareClassStandard,
    },
    {
      key: FlightRatingsEnum[FlightRatingsEnum.premium],
      label: t("fareClass.premiumLabel"),
      details: t("fareClass.premiumDetails"),
      icon: IconNameEnum.fareClassPremium,
    },
    {
      key: FlightRatingsEnum[FlightRatingsEnum.luxury],
      label: t("fareClass.luxuryLabel"),
      details: t("fareClass.luxuryDetails"),
      icon: IconNameEnum.fareClassLuxury,
    },
  ];

  return (
    <div className={clsx(block, className)}>
      <button
        className={cn("item", {
          all: true,
          selected: Object.values(fareClasses).every(
            (fareClass) => fareClass === false
          ),
        })}
        key={"all"}
        onClick={() => {
          handleFilterFareClasses("all");
        }}
      >
        <p className={cn("item-label")}>{t("fareClass.all")}</p>
      </button>
      <div className={cn("items")}>
        {filters.map((filter) => {
          return (
            <button
              key={filter.key}
              className={cn("item", [filter.key], {
                selected: fareClasses[filter.key],
              })}
              onClick={() => {
                handleFilterFareClasses(filter.key as FareclassShelfBrandName);
              }}
            >
              <Icon className={cn("item-icon")} iconName={filter.icon} />
              <p className={cn("item-label")}>{filter.label}</p>
            </button>
          );
        })}
      </div>
      {children}
    </div>
  );
};
